/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Product} from '../../../core/_models'

type Props = {
  product: Product
}

const ActiveInactiveCell: FC<Props> = ({product}) => (
  <div className='d-flex flex-column'>{product.active ? 'Ativo' : 'Inativo'}</div>
)

export {ActiveInactiveCell}
